(() => {
  const selector = '[data-ag-led-card]:not([data-ag-led-ready])';
  const observer = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
        entries.forEach(({ target, isIntersecting }) => {
          target.classList.toggle('is-ag-offscreen', !isIntersecting);
        });
      }, { rootMargin: '100px 0px' })
    : null;

  function init(root = document) {
    if (!observer) return;
    root.querySelectorAll(selector).forEach((card) => {
      card.dataset.agLedReady = 'true';
      observer.observe(card);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
